import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dtp-pagina-inicio',
  templateUrl: './pagina-inicio.component.html',
})
export class PaginaInicioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
